import { PAKKAFORM_ID } from '@/config/constants';
import { getOr } from '@/utils/options';
import Link from 'next/link';
import * as React from 'react';
import { ButtonFieldsFragment } from 'types/generated';
import typewriter, { PackageCardButtonClickedType, Source, Placement, Title } from '@/analytics/segment';
import Button, { variantFromString } from 'components/src/button';
import { useSetAtom } from 'jotai';
import { isDoBusinessWithUsFormAtom } from '@/store';

type Props = {
  buttonData?: ButtonFieldsFragment | null;
  packageName?: string | null;
  source?: Source;
};

const PrimaryButton = ({ buttonData, packageName, source }: Props) => {
  const setIsDoBusinessWithUsForm = useSetAtom(isDoBusinessWithUsFormAtom);
  // const dispatch = useDispatch();

  if (!buttonData || !buttonData?.label) {
    return null;
  }

  if (buttonData.uri) {
    return (
      <Link
        href={`${buttonData.uri}#${PAKKAFORM_ID}`}
        onClick={() => {
          typewriter.packageCardButtonClicked({
            package: getOr(packageName, 'Ekkert nafn á pakka'),
            title: getOr(buttonData.label, 'Enginn texti í takka'),
            type: PackageCardButtonClickedType.Primary,
            ...(Boolean(source) && { source }),
          });
        }}
      >
        <Button label={buttonData.label} variant={variantFromString(buttonData.variant)} autoWidth={false} />
      </Link>
    );
  }

  // If no link is provided, open the "Komdu í viðskipti" form
  return (
    <Button
      label={buttonData.label}
      variant={variantFromString(buttonData.variant)}
      onClick={() => {
        typewriter.doBusinessWithUsButtonClicked({
          placement: Placement.PackageCard,
          title: Title.KomduÍViðskipti,
        });
        setIsDoBusinessWithUsForm(true);
      }}
      autoWidth={false}
    />
  );
};
export default PrimaryButton;
